// external imports
import React from 'react'
import { TextInput, Form, FlexColumn, FlexRow, PrimaryButton, TextArea, triggerAlert } from 'quark-web'
import { isEmail } from 'validator'
// local imports
import { Text } from '~/components'
import styles from './styles'
import { SendContactEmail } from '~/mutations'

const _submit = (data, clear) =>
    SendContactEmail(data, {
        onSuccess: ({ data, errors }) => {
            // if something went wrong
            if (errors) {
                // tell the user something went wrong
                return triggerAlert({
                    type: 'warning',
                    message: `Could not send message. ${errors.join('.')}.`
                })
            }

            // notify the user about the success
            triggerAlert({
                type: 'success',
                message: "Thank you for submitting your message. We'll be in contact shortly."
            })

            // clear the form
            clear()
        }
    })

const ContactForm = ({ style }) => (
    <Form
        validate={{
            name: val => (val && val.length > 0 ? null : 'value is required'),
            company: val => (val && val.length > 0 ? null : 'value is required'),
            address1: val => (val && val.length > 0 ? null : 'value is required'),
            city: val => (val && val.length > 0 ? null : 'value is required'),
            state: val => (val && val.length > 0 ? null : 'value is required'),
            email: val => (val && isEmail(val) ? null : 'value is required'),
            message: val => (val && val.length > 0 ? null : 'value is required'),
            zip: val => (val && val.length > 0 ? null : 'value is required')
        }}
    >
        {({ getValue, setValue, data, hasErrors, clear }) => (
            <FlexColumn style={{marginHorizontal: '20%', marginBottom: '50'}}>
                <FlexRow style={styles.row}>
                    <TextInput
                        placeholder="Name"
                        style={styles.leftInput}
                        value={getValue('name')}
                        onChange={name => setValue({ name })}
                    />
                    <TextInput
                        placeholder="Company"
                        style={styles.input}
                        value={getValue('company')}
                        onChange={company => setValue({ company })}
                    />
                </FlexRow>
                <FlexRow style={styles.row}>
                    <TextInput
                        placeholder="Address Line 1"
                        style={styles.leftInput}
                        value={getValue('address1')}
                        onChange={address1 => setValue({ address1 })}
                    />
                    <TextInput
                        placeholder="Address Line 2"
                        style={styles.input}
                        value={getValue('address2')}
                        onChange={address2 => setValue({ address2 })}
                    />
                </FlexRow>
                <FlexRow style={styles.row}>
                    <TextInput
                        placeholder="City"
                        style={styles.longInput}
                        value={getValue('city')}
                        onChange={city => setValue({ city })}
                    />
                    <TextInput
                        placeholder="State"
                        style={styles.state}
                        value={getValue('state')}
                        onChange={state => setValue({ state })}
                    />
                    <TextInput
                        placeholder="ZIP"
                        style={styles.zip}
                        value={getValue('zip')}
                        onChange={zip => setValue({ zip })}
                    />
                </FlexRow>
                <FlexRow style={styles.row}>
                    <TextInput
                        placeholder="Phone"
                        style={styles.leftInput}
                        value={getValue('phone')}
                        onChange={phone => setValue({ phone })}
                    />
                    <TextInput
                        placeholder="Fax"
                        style={styles.input}
                        value={getValue('fax')}
                        onChange={fax => setValue({ fax })}
                    />
                </FlexRow>
                <FlexRow style={styles.row}>
                    <TextInput
                        placeholder="Email"
                        style={styles.fullInput}
                        value={getValue('email')}
                        onChange={email => setValue({ email })}
                    />
                </FlexRow>
                <FlexRow style={styles.row}>
                    <TextInput
                        placeholder="Message"
                        multiline={true}
                        style={styles.message}
                        value={getValue('message')}
                        onChange={message => setValue({ message })}
                    />
                </FlexRow>
                <FlexRow style={styles.bottomRow}>
                    <PrimaryButton disabled={hasErrors} onPress={() => _submit(data, clear)}>
                        Submit Form
                    </PrimaryButton>
                </FlexRow>
            </FlexColumn>
        )}
    </Form>
)

const mobileContactForm = ({ style }) => (
    <Form
        validate={{
            name: val => (val && val.length > 0 ? null : 'value is required'),
            company: val => (val && val.length > 0 ? null : 'value is required'),
            address1: val => (val && val.length > 0 ? null : 'value is required'),
            city: val => (val && val.length > 0 ? null : 'value is required'),
            state: val => (val && val.length > 0 ? null : 'value is required'),
            email: val => (val && isEmail(val) ? null : 'value is required'),
            message: val => (val && val.length > 0 ? null : 'value is required'),
            zip: val => (val && val.length > 0 ? null : 'value is required')
        }}
    >
        {({ getValue, setValue, data, hasErrors, clear }) => (
            <FlexColumn style={{marginHorizontal: '10%', marginBottom: '50'}}>
                <TextInput
                    placeholder="Name"
                    style={styles.input}
                    value={getValue('name')}
                    onChange={name => setValue({ name })}
                />
                <TextInput
                    placeholder="Company"
                    style={styles.input}
                    value={getValue('company')}
                    onChange={company => setValue({ company })}
                />
                <TextInput
                    placeholder="Address Line 1"
                    style={styles.input}
                    value={getValue('address1')}
                    onChange={address1 => setValue({ address1 })}
                />
                <TextInput
                    placeholder="Address Line 2"
                    style={styles.input}
                    value={getValue('address2')}
                    onChange={address2 => setValue({ address2 })}
                />
                <TextInput
                    placeholder="City"
                    style={styles.input}
                    value={getValue('city')}
                    onChange={city => setValue({ city })}
                />
                <FlexRow>
                    <TextInput
                        placeholder="State"
                        style={styles.state}
                        value={getValue('state')}
                        onChange={state => setValue({ state })}
                    />
                    <TextInput
                        placeholder="ZIP"
                        style={styles.zip}
                        value={getValue('zip')}
                        onChange={zip => setValue({ zip })}
                    />
                </FlexRow>
                <TextInput
                    placeholder="Phone"
                    style={styles.input}
                    value={getValue('phone')}
                    onChange={phone => setValue({ phone })}
                />
                <TextInput
                    placeholder="Fax"
                    style={styles.input}
                    value={getValue('fax')}
                    onChange={fax => setValue({ fax })}
                />
                <TextInput
                    placeholder="Email"
                    style={styles.input}
                    value={getValue('email')}
                    onChange={email => setValue({ email })}
                />
                <TextInput
                    placeholder="Message"
                    multiline={true}
                    style={styles.message}
                    value={getValue('message')}
                    onChange={message => setValue({ message })}
                />
                <FlexRow style={styles.bottomRow}>
                    <PrimaryButton disabled={hasErrors} onPress={() => _submit(data, clear)}>
                        Submit Form
                    </PrimaryButton>
                </FlexRow>
            </FlexColumn>
        )}
    </Form>
)

function getSize(){
    let width = screen.width;

    if (width < 768){
        return mobileContactForm
    } 
    return ContactForm
}

export default getSize()



// WEBPACK FOOTER //
// ./src/views/Contact/Form/index.js